export const Form =  {
    parts: ["input", "button"],
    baseStyle: {
        input: {
            errorBorderColor: "error", 
            borderColor: "gray.borders", 
            borderRadius: "4px",
            bg: "white", 
            w: "345px", 
            h:"46px",
        },
        button: {

        }
    },
    sizes: {},
    variants: {},
    defaultProps: {
        size: "md"
    },
};